
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Corporatecabserviceinpune() {



    const cardData =
    {
        keyword: 'Corporate Cab Service in Pune',
        heading: 'Platinum24 Cabs: Corporate Cab Service in Pune',
        headingDescription: ' Platinum24 Cabs delivers reliable Corporate Cab Service in Pune, designed for businesses that value punctuality, comfort, and professionalism. We provide a dedicated fleet of hatchbacks, sedans, SUVs, and luxury cars to meet the daily travel, client transfers, airport pickups, and outstation needs of corporate teams. With trained chauffeurs, real-time support, and flexible rental packages, we ensure stress-free travel for executives and employees alike. Whether it’s conferences, meetings, or regular staff commutes, Platinum24 Cabs offers tailored corporate cab solutions that combine efficiency, affordability, and premium service standards.',

        top: 'Top Places to Visit in Pune with Platinum24 Cabs',

"topPlaces": [
  {
    "title": "Shaniwar Wada",
    "description": "Shaniwar Wada, built in 1732, is Pune’s iconic fort palace and a symbol of Maratha pride. Once the seat of the Peshwas, it narrates tales of power and grandeur. Though partially destroyed by fire in 1828, its mighty gates, fountains, and ruins still attract thousands. The evening light-and-sound show recreates the era of Bajirao and Mastani. Tourists love exploring its historic corridors and gardens. Shaniwar Wada is Pune’s proud heritage landmark."
  },
  {
    "title": "Aga Khan Palace",
    "description": "The Aga Khan Palace, built in 1892, is one of Pune’s most beautiful monuments with Indo-Italian architecture. It is historically important as Mahatma Gandhi, Kasturba Gandhi, and Sarojini Naidu were imprisoned here during the Quit India Movement. The palace now serves as a museum showcasing Gandhi’s personal belongings and photos. Its sprawling lawns make it peaceful and picturesque. It is also a national memorial to Kasturba Gandhi. Aga Khan Palace is Pune’s symbol of freedom and heritage."
  },
  {
    "title": "Sinhagad Fort",
    "description": "Sinhagad Fort, located 25 km from Pune, is famous for the 1670 battle fought by Tanaji Malusare for Chhatrapati Shivaji Maharaj. The fort offers panoramic views of the Sahyadris and is a popular trekking destination. Visitors explore bastions, temples, and memorials that echo Maratha bravery. In monsoon, waterfalls and mist make it magical. Locals serve traditional pithla-bhakri at the fort. Sinhagad is Pune’s blend of history, adventure, and nature."
  },
  {
    "title": "Dagdusheth Halwai Ganpati Temple",
    "description": "The Shreemant Dagdusheth Halwai Ganpati Temple is Pune’s most revered shrine, dedicated to Lord Ganesha. The idol, adorned with gold and jewels, is a major attraction during Ganesh Chaturthi when grand celebrations take place. The temple also runs charitable trusts and cultural events. Devotees from all over India visit year-round for darshan. Its spiritual aura is both vibrant and peaceful. Dagdusheth Ganpati is Pune’s divine and cultural heart."
  },
  {
    "title": "Pataleshwar Cave Temple",
    "description": "Pataleshwar Cave Temple, carved in the 8th century, is an ancient rock-cut shrine dedicated to Lord Shiva. Located in the heart of the city, it offers peace away from the urban buzz. The temple features huge stone pillars, a Nandi mandapa, and detailed carvings. Evening prayers add to its mystical ambiance. It showcases India’s ancient architectural craftsmanship. Pataleshwar is Pune’s hidden spiritual heritage gem."
  },
  {
    "title": "Raja Dinkar Kelkar Museum",
    "description": "Raja Dinkar Kelkar Museum houses over 20,000 artifacts collected by Dr. Dinkar Kelkar, reflecting India’s cultural traditions. Exhibits include musical instruments, sculptures, ornaments, and household antiques. The recreation of Mastani Mahal is a highlight. History enthusiasts and students find it educational and fascinating. The museum preserves art spanning centuries. It is Pune’s cultural and artistic treasure trove."
  },
  {
    "title": "Parvati Hill and Temple",
    "description": "Parvati Hill, one of Pune’s oldest landmarks, offers panoramic views of the city. At the hilltop stands the Parvati Temple, dedicated to Lord Shiva and Goddess Parvati, built during the Peshwa era. The climb of 103 steps is a blend of devotion and adventure. The hill also houses museums and smaller shrines. Sunrise and sunset views from here are breathtaking. Parvati Hill is Pune’s sacred and scenic retreat."
  },
  {
    "title": "Osho Ashram",
    "description": "The Osho International Meditation Resort in Koregaon Park is a global hub for spirituality and wellness. Spread across lush gardens, it attracts visitors from all over the world. The ashram offers meditation sessions, yoga, and personal growth workshops. Japanese Zen gardens and serene meditation halls enhance the experience. It is a place for peace, rejuvenation, and self-discovery. Osho Ashram is Pune’s international center of tranquility."
  },
  {
    "title": "Pu La Deshpande Garden",
    "description": "Pu La Deshpande Garden, also known as the Okayama Friendship Garden, is Pune’s largest landscaped park. Inspired by Japan’s Korakuen Garden, it features streams, stone bridges, and manicured lawns. Families enjoy peaceful strolls, picnics, and photography here. The garden symbolizes Indo-Japanese friendship and culture. Seasonal flowers make it more enchanting. Pu La Deshpande Garden is Pune’s green paradise of calm and beauty."
  },
  {
    "title": "Khadakwasla Dam",
    "description": "Khadakwasla Dam, built on the Mutha River, is a popular weekend spot near Pune. It supplies water to the city while offering scenic views of hills and flowing waters. During monsoon, the overflowing dam creates spectacular sights. Street vendors selling hot corn and tea add charm to the visit. It also serves as a gateway to Sinhagad Fort. Khadakwasla is Pune’s refreshing natural retreat for families and travelers alike."
  }
],



 "services": [
    {
      "name": "Pune Corporate Cab Service",
      "description": "Professional corporate cab services in Pune designed for business travelers, office commutes, and corporate events with punctual and reliable rides."
    },
    {
      "name": "Corporate Taxi Service Pune",
      "description": "Dedicated corporate taxi service offering seamless travel solutions for companies and professionals in Pune."
    },
    {
      "name": "Business Taxi Hire Pune",
      "description": "Flexible and affordable business taxi hire options for Pune-based companies and corporate clients."
    },
    {
      "name": "Corporate Car Rentals Pune",
      "description": "Wide range of corporate car rentals in Pune with self-drive and chauffeur options suitable for business needs."
    },
    {
      "name": "Employee Cab Service Pune",
      "description": "Specialized employee cab services in Pune to ensure safe and timely transport for your staff."
    },
    {
      "name": "Pune Office Taxi Booking",
      "description": "Efficient taxi booking services for Pune offices with options for daily commutes and business trips."
    },
    {
      "name": "Corporate Chauffeur Service Pune",
      "description": "Experienced chauffeur services for corporate clients in Pune, focusing on professionalism and comfort."
    },
    {
      "name": "Reliable Corporate Cabs Pune",
      "description": "Trustworthy corporate cab service in Pune with verified drivers and well-maintained vehicles."
    },
    {
      "name": "Pune Business Ride Service",
      "description": "Business ride services tailored for corporate travelers in Pune with punctual pickups and drop-offs."
    },
    {
      "name": "Corporate Taxi Booking Online Pune",
      "description": "Easy online booking platform for corporate taxi services in Pune with instant confirmation."
    },
    {
      "name": "Corporate Travel Taxi Pune",
      "description": "Corporate travel taxi solutions in Pune for business tours, client visits, and executive transfers."
    },
    {
      "name": "Company Cab Service Pune",
      "description": "Company cab services for Pune businesses to manage employee transportation efficiently."
    },
    {
      "name": "Corporate Event Taxi Pune",
      "description": "Reliable taxi services for corporate events and conferences in Pune ensuring smooth logistics."
    },
    {
      "name": "Executive Cab Service Pune",
      "description": "Premium executive cab services in Pune offering luxury vehicles and professional drivers for business leaders."
    },
    {
      "name": "Pune Corporate Cab Packages",
      "description": "Flexible and comprehensive corporate cab packages in Pune tailored to meet business travel requirements."
    }
  ],
  "tableData": [
    ["Pune Corporate Cab Service", "Corporate Taxi Service Pune"],
    ["Business Taxi Hire Pune", "Corporate Car Rentals Pune"],
    ["Employee Cab Service Pune", "Pune Office Taxi Booking"],
    ["Corporate Chauffeur Service Pune", "Reliable Corporate Cabs Pune"],
    ["Pune Business Ride Service", "Corporate Taxi Booking Online Pune"],
    ["Corporate Travel Taxi Pune", "Company Cab Service Pune"],
    ["Corporate Event Taxi Pune", "Executive Cab Service Pune"],
    ["Pune Corporate Cab Packages", "—"]
  ],


    "whychoose": [
    {
      "WhyChooseheading": "Premium Corporate Cab Service in Pune",
      "WhyChoosedescription": "Platinum24 Cabs offers professional and punctual cab services tailored for corporate clients in Pune."
    },
    {
      "WhyChooseheading": "On-Time Pickups and Drop-offs for Business Meetings",
      "WhyChoosedescription": "Ensure timely arrival for all your corporate commitments with our reliable cab scheduling."
    },
    {
      "WhyChooseheading": "Well-Maintained Fleet for Executive Travel",
      "WhyChoosedescription": "Travel in style and comfort with our clean, air-conditioned vehicles perfect for professionals."
    },
    {
      "WhyChooseheading": "Trained Chauffeurs with Corporate Etiquette",
      "WhyChoosedescription": "Our drivers are trained to handle corporate travel with professionalism, privacy, and courtesy."
    },
    {
      "WhyChooseheading": "Flexible Billing Options for Businesses",
      "WhyChoosedescription": "We provide easy monthly billing, GST-compliant invoices, and corporate account management."
    },
    {
      "WhyChooseheading": "Custom Packages for Daily Office Commute",
      "WhyChoosedescription": "Get affordable and customizable packages for employee pick-up and drop-off across Pune."
    },
    {
      "WhyChooseheading": "24/7 Availability for Late-Night or Early-Morning Rides",
      "WhyChoosedescription": "Our round-the-clock service ensures your team is covered at any hour of the day."
    },
    {
      "WhyChooseheading": "Real-Time Tracking and Safe Travel",
      "WhyChoosedescription": "Monitor every ride with GPS tracking and enjoy safe, secure transportation for your employees and clients."
    }
  ]


















    }


const faqData = [
    {
        question: 'Does Platinum24 Cabs offer corporate cab services in Pune?',
        answer: 'Yes, Platinum24 Cabs provides dedicated corporate cab services in Pune designed to meet the needs of businesses and professionals.',
    },
    {
        question: 'How can companies book corporate cab services with Platinum24 Cabs in Pune?',
        answer: 'Companies can book corporate cab services through our website, mobile app, or by contacting our corporate support team directly.',
    },
    {
        question: 'What types of vehicles are available for corporate cab services in Pune?',
        answer: 'We offer a range of premium vehicles including sedans, SUVs, and luxury cars suitable for corporate travel in Pune.',
    },
    {
        question: 'Are corporate cab drivers experienced and professional in Pune?',
        answer: 'Yes, all corporate cab drivers are trained, professional, and experienced to provide safe and punctual rides for business clients.',
    },
    {
        question: 'Can I get customized billing and invoicing for corporate cab services in Pune?',
        answer: 'Absolutely! We offer flexible billing and invoicing options tailored to your company’s requirements.',
    },
    {
        question: 'Does Platinum24 Cabs provide priority support for corporate clients in Pune?',
        answer: 'Yes, our corporate clients receive priority customer support to ensure smooth and timely travel experiences.',
    },
    {
        question: 'Can I schedule regular pickups and drop-offs for corporate employees in Pune?',
        answer: 'Yes, we offer scheduled and recurring cab services to accommodate regular corporate transportation needs.',
    },
    {
        question: 'Are safety and hygiene protocols followed in corporate cab services in Pune?',
        answer: 'Yes, all vehicles are sanitized regularly and drivers follow strict safety guidelines to ensure a safe ride.',
    },
    {
        question: 'Is it possible to book corporate cabs for outstation trips from Pune?',
        answer: 'Yes, we provide corporate outstation cab services including trips from Pune to nearby cities and business hubs.',
    },
];

const testimonials = [
    {
        id: 1,
        name: 'Mr. Arvind Joshi',
        feedback: 'The corporate cab service by Platinum24 Cabs in Pune has been reliable and efficient for our company’s daily employee transportation.',
        rating: 5,
    },
    {
        id: 2,
        name: 'Ms. Sneha Kulkarni',
        feedback: 'Platinum24 Cabs offers excellent corporate travel solutions in Pune with professional drivers and hassle-free billing.',
        rating: 5,
    },
];
































    const Images = [
        { place: "/images/keyword/1.jpg", text: "Pune Cab Service", link: "pune-cab-service" },
        { place: "/images/keyword/2.jpg", text: "Pune Taxi Hire", link: "pune-taxi-hire" },
        { place: "/images/keyword/3.jpg", text: "Pune Online Cab Booking", link: "pune-online-cab-booking" },
        { place: "/images/keyword/4.jpg", text: "Best Cab Service in Pune", link: "best-cab-service-in-pune" },
        { place: "/images/keyword/5.jpg", text: "Pune to Mumbai Cabs", link: "pune-to-mumbai-cabs" },
        { place: "/images/keyword/6.jpg", text: "Pune to Nashik Cabs", link: "pune-to-nashik-cabs" },
        { place: "/images/keyword/7.jpg", text: "Pune to Mahabaleshwar Cabs", link: "pune-to-mahabaleshwar-cabs" },
        { place: "/images/keyword/8.jpg", text: "Pune to Lonavala Cabs", link: "pune-to-lonavala-cabs" },
        { place: "/images/keyword/9.jpg", text: "Pune to Shirdi Cab", link: "pune-to-shirdi-cab" },
        { place: "/images/keyword/10.jpg", text: "Pune to Bhimashankar Cab", link: "pune-to-bhimashankar-cab" },
        { place: "/images/keyword/11.jpg", text: "Pune to Konkan Darshan Cabs", link: "pune-to-konkan-darshan-cabs" },
        { place: "/images/keyword/12.jpg", text: "Pune Outstation Cabs", link: "pune-outstation-cabs" },
        { place: "/images/keyword/13.jpg", text: "Ashtavinayak Darshan Cab", link: "ashtavinayak-darshan-cab" },
        { place: "/images/keyword/14.jpg", text: "Pune to Goa Cabs", link: "pune-to-goa-cabs" },
        { place: "/images/keyword/15.jpg", text: "Cabs Services Near Me", link: "cabs-services-near-me" },
        { place: "/images/keyword/16.jpg", text: "Corporate Cab Service in Pune", link: "corporate-cab-service-in-pune" },
        { place: "/images/keyword/17.jpg", text: "Pune to Mumbai Airport Cabs", link: "pune-to-mumbai-airport-cabs" },
        { place: "/images/keyword/18.jpg", text: "Tempo Traveller On Rent in Pune", link: "tempo-traveller-on-rent-in-pune" },
        { place: "/images/keyword/19.jpg", text: "Urbania On Rent in Pune", link: "urbania-on-rent-in-pune" },
        { place: "/images/keyword/20.jpg", text: "Innova Crysta On Rent in Pune", link: "innova-crysta-on-rent-in-pune" },
        { place: "/images/keyword/21.jpg", text: "Bus On Rent in Pimpri Chinchwad", link: "bus-on-rent-in-pimpri-chinchwad" },
        { place: "/images/keyword/22.jpg", text: "Mini Bus On Rent in Pune", link: "mini-bus-on-rent-in-pune" },
        { place: "/images/keyword/23.jpg", text: "Ertiga On Rent in Pune", link: "ertiga-on-rent-in-pune" },
        { place: "/images/keyword/24.jpg", text: "Pune to Sambhaji Nagar Taxi", link: "pune-to-sambhaji-nagar-taxi" },
        { place: "/images/keyword/25.jpg", text: "Pune to Ganpatipule Taxi", link: "pune-to-ganpatipule-taxi" }
    ];








const corporateCabServicePuneSchema = {
  "@context": "https://schema.org",
  "@type": "Service",
  "name": "Corporate Cab Service in Pune",
  "image": "https://www.platinum24cab.com/assets/images/corporate-cab-service-pune.jpg",
  "description": "Book reliable corporate cab services in Pune with Platinum24 Cabs. Business taxi hires, corporate car rentals, chauffeur services, and executive cab packages tailored for your company needs.",
  "brand": {
    "@type": "Brand",
    "name": "Platinum24 Cabs"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "availability": "https://schema.org/InStock",
    "url": "https://www.platinum24cab.com/corporate-cab-service-pune"
  }
};





    return (
        <div>

<Helmet>
  <title>Corporate Cab Service in Pune | Business Taxi Hire | Platinum24 Cabs</title>
  <meta
    name="description"
    content="Book reliable corporate cab services in Pune with Platinum24 Cabs. Business taxi hires, corporate car rentals, chauffeur services, and executive cab packages tailored for your company needs."
  />
  <meta
    name="keywords"
    content="Pune Corporate Cab Service, Corporate Taxi Service Pune, Business Taxi Hire Pune, Corporate Car Rentals Pune, Employee Cab Service Pune, Pune Office Taxi Booking, Corporate Chauffeur Service Pune, Reliable Corporate Cabs Pune, Pune Business Ride Service, Corporate Taxi Booking Online Pune, Corporate Travel Taxi Pune, Company Cab Service Pune, Corporate Event Taxi Pune, Executive Cab Service Pune, Pune Corporate Cab Packages"
  />
  <script type="application/ld+json">
    {JSON.stringify(corporateCabServicePuneSchema)}
  </script>
</Helmet>


            <div
                className="breadcumb-wrapper"
                // style={{ backgroundImage: "url('/img/breadcumb/breadcumb-bg.jpg')" }}
            >
                <div className="container z-index-common">
                    <div className="breadcumb-content">
                        <h1 className="breadcumb-title">{cardData.keyword}</h1>
                        <div className="breadcumb-menu-wrap">
                        </div>
                    </div>
                </div>
            </div>










            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/16.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#183765', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="topPlaces">
                                <p className="sectionLead">{cardData.top}</p>

                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>
                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>
                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div key={index} className="service-row">
                                        <div className="service-icon">
                                            🚖
                                        </div>
                                        <div>
                                            <h4 className="service-title">{service.name}</h4>
                                            <p className="service-desc">{service.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>


                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section" className="why-choose-section">


                                {/* Section Title */}
                                <h2 className="section-title">
                                    Why Choose <span>Platinum24 Cabs</span>
                                </h2>

                                {/* Cards */}
                                <div className="cards-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div key={index} className="why-card">
                                            <div className="icon-circle">{index + 1}</div>
                                            <h4 className="card-heading">{item.WhyChooseheading}</h4>
                                            <p className="card-desc">{item.WhyChoosedescription}</p>
                                        </div>
                                    ))}
                                </div>
                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Platinum24 Cabs </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title="Frequently Asked"
                                                    subtitle="Help & Info"
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-telephone-fill"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+917507048333" className="pc-call">+91 7507048333</a>
                                        </div>

                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/917507048333"
                                                target="_blank" rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp me-1"></i> WhatsApp
                                            </a>
                                            <a href="tel:+917507048333" className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-envelope-fill"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@platinum24cab.com" className="pc-email">
                                            booking@platinum24cab.com
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-house-fill"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Platinum24 Cabs</strong><br />
                                            OFFICE NO.2, SECTOR NO.4, PLOT NO.295(S), SAI GANGA APARTMENT, ABOVE UMED ELECTRICAL, NEAR ACORD HOSPITAL
                                            FIRST FLOOR, SANT NAGAR, MOSHI, PUNE 412105
                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Corporatecabserviceinpune;